module.exports = __webpack_public_path__ + "ptsansbold.6abfcfb5.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/src/assets/fonts/ptsans/ptsansbold.woff2
// module id = 2387
// module chunks = 0